import { consoleInfo } from '@gravityforms/utils';
import googlePlaces from './google-places';
import userLocation from './user-location';

/**
 * @function init
 * @description Kick off this module's functionality
 *
 * @since 1.0
 *
 */

const init = () => {
	googlePlaces();
	userLocation();

	consoleInfo(
		'Gravity Forms Geolcation JS: Initialized..'
	);
};

export default init;
